module.exports = __webpack_public_path__ + "img/icon-report-triangle.21cdc676.svg";